import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    resources: {
      en: {
        translation: {
          text_elevator_alarm: "Elevator Alarm",
          text_normal: "Normal",
          text_fire_alarm: "Disabled Toilet",
          text_tenant_intercom: "Roof Exit",
          text_25F_motion: "Motion on 25th Floor",
          text_fresh_water_pump_status: "Water Leakage(s)",
          text_flush_water_pump_status: "Washing Machine(s) In-Use",
          text_dryers_in_use: "Dryer(s) In-Use",
          text_select_floor: "Select floor",
          text_not_found: "Not Found",
          text_villa_rhapsody: "Symphony Bay Villa Rhapsody",
          text_floor: "Floor",
          text_floor1: "Floor",
          text_in_use: "In-Use",
          text_idle: "Idle",
          test_elevator_alarm_detected: "Poor",
          text_logout: "Logout",
          text_dashboard: "Dashboard",
          text_floors: "Blocks",
          text_menu: "Menu",
          text_active: "Active",
          test_fire_alarm_detected: "Fall Detected",
          text_tenant_intercom_alarm_detected: "Motion Detected",
          text_elevator_alarm_detected: "Leak Detected",
          text_water_leakage: "Water Leakage",
          text_washing_machine: "Washing Machine",
          text_tenant_alarm: "Air Quality",
          text_exit_detection: "Exit",
          text_dryer: "Dryer",
          text_fall_detection: "Fall Detection",
              text_error: "Sorry, an unexpected error has occurred.",
              "text_sound_on": "Sound On",
              "text_sound_off": "Sound Off",
              text_eventlog: "Event Log",
        },
      },
      zh_HK: {
        translation: {
          text_elevator_alarm: "升降機警報",
          text_normal: "正常",
          text_fire_alarm: "消防警報",
          text_tenant_intercom: "住戶緊急警報",
          text_25F_motion: "25樓在場檢測",
          text_fresh_water_pump_status: "食水泵狀態",
          text_flush_water_pump_status: "咸水泵狀態",
          text_dryers_in_use: "食水泵狀態",
          text_select_floor: "選擇座數",
          text_not_found: "Not Found",
          text_villa_rhapsody: "帝琴灣凱琴居",
          text_floor: "樓層",
          text_floor1: "樓",
          text_in_use: "使用中",
          text_idle: "可使用",
          test_elevator_alarm_detected: "升降機警報",
          text_logout: "登出",
          text_dashboard: "訊息中心",
          text_floors: "樓層",
          text_menu: "菜單",
          text_active: "使用中",
              test_fire_alarm_detected: "消防警報",
          text_tenant_intercom_alarm_detected: "警報",
          text_elevator_alarm_detected: "漏水",
          text_water_leakage: "漏水檢測",
          text_washing_machine: "洗衣機",
          text_tenant_alarm: "住戶警報",
          text_exit_detection: "通道檢測",
          text_dryer: "乾衣機",
          text_fall_detection: "跌倒檢測",
              text_error: "抱歉，發生意外錯誤",
              "text_sound_on": "Sound On",
              "text_sound_off": "Sound Off",
              text_eventlog: "過往記錄,"
        },
      },
    },
    interpolation: {
      escapeValue: false,
    },
  });
i18n.changeLanguage("zh_HK");
export default i18n;
